export const generateColumn = ({ Header, accessor, width, Cell, allowShrinking = false }) => ({
  Header,
  accessor,
  width,
  maxWidth: width,
  minWidth: allowShrinking ? 0 : width,
  Cell,
});
